import styled from "styled-components";
import { pxToRem } from "@input-output-hk/px-to-rem";

export const PaginationContainer = styled.div`
  margin-top: ${pxToRem(85)};
`;
